import { client } from '../client';
import { Insurance, UserRoleName } from './types/UserProfile';

export const removePatientInsurance = async (user_id?: number, userRole?: UserRoleName): Promise<Insurance> => {
  const basePath = userRole === UserRoleName.Collector ? '/collector/insurances/current' : '/insurances/current';
  const { data } = await client.delete<Insurance>(`${basePath}${user_id ? `?user_id=${user_id}` : ''}`);

  return data;
};
